exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}



/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/motion/js-deps/~/deep-equal/lib/keys.js
 ** module id = 280
 ** module chunks = 1
 **/